//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const buckler = [
    0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 
    0, 0, 5, 5, 3, 2, 2, 3, 5, 5, 0, 0, 
    0, 0, 5, 3, 2, 2, 2, 2, 3, 5, 0, 0, 
    0, 0, 3, 2, 2, 2, 4, 2, 2, 3, 0, 0, 
    0, 3, 2, 2, 2, 2, 1, 2, 2, 2, 3, 0, 
    3, 2, 2, 4, 1, 1, 1, 2, 2, 2, 2, 3, 
    3, 2, 2, 2, 2, 1, 1, 1, 4, 2, 2, 3, 
    0, 3, 2, 2, 2, 1, 2, 2, 2, 2, 3, 0, 
    0, 0, 3, 2, 2, 4, 2, 2, 2, 3, 0, 0, 
    0, 0, 5, 3, 2, 2, 2, 2, 3, 5, 0, 0, 
    0, 0, 5, 5, 3, 2, 2, 3, 5, 5, 0, 0, 
    0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0,
]